export const GA_TRACKING_ID = 'G-ZRZVTPQXL9';

// Initialize GA
export const initGA = () => {
    const script1 = document.createElement('script');
    script1.async = true;
    script1.src = `https://www.googletagmanager.com/gtag/js?id=${GA_TRACKING_ID}`;
    
    const script2 = document.createElement('script');
    script2.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', '${GA_TRACKING_ID}');
    `;
    
    document.head.appendChild(script1);
    document.head.appendChild(script2);
  };
  
  export const pageView = (url) => {
    window.gtag('config', GA_TRACKING_ID, {
      page_path: url,
    });
  };
  
  export const event = ({ action, category, label, value }) => {
    window.gtag('event', action, {
      event_category: category,
      event_label: label,
      value: value,
    });
  };